import React from 'react';
import PropTypes from 'prop-types';
import _round from 'lodash/round';

class FloatInLimits extends React.PureComponent {
  static propTypes = {
    min: PropTypes.number,
    max: PropTypes.number,
    precision: PropTypes.number,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string,
    children: PropTypes.element,
  };

  constructor(props) {
    super(props);
    const { min, max, precision } = props;
    this.errorMessage = `Value must be between ${_round(min, precision)} - ${_round(max, precision)}`;
  }

  handleKeyPress = (event) => {
    if (!'-.0123456789'.includes(event.key)) {
      event.preventDefault();
    }
  }

  handleBlur = (e) => {
    this.handleChange(e, { name: e.target.name, value: e.target.value });
  }

  handleChange = (event, props) => {
    const { onChange, max, min, precision } = this.props;
    const { value } = props;

    if (!value || value === '-' || value === '.' || value === '0' || value === '0.') {
      onChange(event, {
        ...props,
        value,
        isInvalid: false,
        error: null,
      });
    } else {
      const parsed = parseFloat(value, 10);
      /* istanbul ignore else */
      if (!Number.isNaN(parsed)) {
        const nums = value.split('.');
        /* istanbul ignore else */
        if (nums.length <= 2) {
          const [ints, decimal] = nums;

          if (parsed <= max) {
            const newDecimal = decimal && decimal.length > precision ? decimal.substring(0, precision): null;
            const newValue = newDecimal ? `${ints}.${newDecimal}`: value;
            const isInvalid = parsed < min;

            onChange(event, {
              ...props,
              value: newValue,
              isInvalid: false,
              error: isInvalid ? this.errorMessage: null,
            });
          } else {
            onChange(event, {
              ...props,
              value,
              isInvalid: true,
              error: this.errorMessage,
            });
          }
        }
      }
    }
  }

  render() {
    const { children } = this.props;
    return React.Children.map(children, (child) => (
      React.cloneElement(child, {
        onKeyPress: this.handleKeyPress,
        onBlur: this.handleBlur,
        onChange: this.handleChange,
      })
    ));
  }
}

export default FloatInLimits;
